import React from "react";

export default function ErrorBox() {
  return (
    <div className="verify__alert">
      <span>
        <img src="/assets/icons/alert-triangle.svg" alt="alert" />
      </span>
      <span>
        Your appointment date for service is before your equipment arrives,
        please recheck your dates and try again
      </span>
    </div>
  );
}
